import React, { FC, useState } from 'react';
import moment from 'moment';
import { faTrophy } from '@fortawesome/free-solid-svg-icons/faTrophy';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import Button, {
  BUTTON_SIZES,
  BUTTON_TYPES,
  BUTTON_WIDTHS
} from 'buyside/components/presentation/Button/button';
import Countdown from 'buyside/components/presentation/Countdown/countdown';

import { contestUrl } from 'buyside/util/urlHelper';
import { useIsMobile, useInterval } from 'buyside/util/hooks';

import { FeaturedContestQuery } from 'interfaces/graphql-typings';

import styles from './sideNavigationContestBannerStyles.scss';

const SideNavigationContestBanner: FC<{
  contests: NonNullable<FeaturedContestQuery['featuredContests']>;
}> = ({ contests }) => {
  const [slideNum, setSlideNum] = useState(0);
  const isMobile = useIsMobile();

  const contestCount = contests.length;
  useInterval(
    () => setSlideNum(prevState => (prevState === contestCount - 1 ? 0 : prevState + 1)),
    5000,
    5000
  );

  return (
    <div className={styles.slideshowContainer}>
      <div
        className={styles.slideshowSlider}
        style={{ transform: `translate3d(${-slideNum * 100}%, 0, 0)` }}
      >
        {contests.map((contest, index) => {
          const { id, active, countdownDate, name } = contest;
          const daysToCountdown = moment(new Date(countdownDate || '')).diff(moment(), 'days') + 1;
          return (
            <div className={styles.slide} key={index}>
              <div className={styles.sideNavigationContestBanner}>
                <FontAwesomeIcon icon={faTrophy} />
                <div data-testid="contest">
                  The {name} Contest {active ? 'ends' : 'starts'} in{' '}
                  {daysToCountdown >= 3 ? (
                    <strong>{daysToCountdown} days.</strong>
                  ) : (
                    <div className={styles.countdown}>
                      {countdownDate && <Countdown date={new Date(countdownDate)} />}
                    </div>
                  )}
                </div>
                <Button
                  url={contestUrl(id)}
                  size={isMobile ? BUTTON_SIZES.SMALL : BUTTON_SIZES.TINY}
                  text="View Contest"
                  width={BUTTON_WIDTHS.FULL}
                  type={BUTTON_TYPES.PRIMARY}
                />
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default SideNavigationContestBanner;
